// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"131":"a461aa5a","212":"6904c380","599":"294dcc11"}[chunkId] + ".css";
};